import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import InsuredDeclaredValue from './InsuredDeclaredValue';
import PlanType from './PlanType';
import PromotionCode from './promotion-code';
import { FilterAddonCover } from './filter-addon-cover';
import { FilterCategory } from './filter-category';

const FilterSection = () => {
  return (
    <Container className="shadow rounded">
      <Row>
        <Col lg={2}>
          <InsuredDeclaredValue />
        </Col>
        <Col lg={2}>
          <FilterCategory />
        </Col>
        <Col lg={2}>
          <PlanType />
        </Col>
        <Col lg={6}>
          <FilterAddonCover />
        </Col>
      </Row>
      <Row>
        <Col lg={2} className="mb-3">
          <PromotionCode />
        </Col>
      </Row>
    </Container>
  );
};

export { FilterSection };
